import React from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { Formik } from 'formik';
import Button from '../common/button';
import { usePasswordReset } from './hooks';
import PasswordRules from '../common/PasswordRules';
import { LoginSVG } from '../../img/GlobalSVG';
import GenericButton from '../../../Components/GenericButton/GenericButton';
import ApiEncrypt from '../../utils/Encrypt';

const PasswordReset = ({
  email,
  currentStep,
  nextStep,
  passwordRules,
  userDetails,
  flowName,
}) => {
  const {
    schema,
    showPassword,
    showConfirmPassword,
    serverError,
    setShowPassword,
    setShowConfirmPassword,
    resetPassword,
  } = usePasswordReset({ passwordRules, userDetails, flowName });

  const { encryptData } = ApiEncrypt();

  if (serverError) {
    return <Navigate to="/admin/server-error" push={true}></Navigate>;
  }
  return currentStep === 4 ? (
    <Col
      md={8}
      className="password-reset-container password-reset-container-box"
    >
      <Row>
        <Col md={12}>
          <Formik
            validationSchema={schema}
            initialValues={{ password: '', confirmPassword: '' }}
            onSubmit={(values, actions) => {
              actions.setStatus(undefined);
              const encryptPassword = encryptData(values.password, false);
              resetPassword(email, encryptPassword)
                .then(() => {
                  nextStep();
                  console.log('next step');
                })
                .catch((error) => {
                  actions.setStatus({
                    confirmPassword: error,
                  });
                });
            }}
          >
            {({
              values,
              touched,
              errors,
              status,
              handleSubmit,
              handleChange,
              handleBlur,
              setStatus,
            }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="position-relative">
                    <Form.Label className="mb-0">
                      New Password <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Control
                      type={showPassword ? 'text' : 'password'}
                      name="password"
                      placeholder=""
                      className={status && status.password ? 'is-invalid' : ''}
                      value={values.password}
                      isInvalid={errors.password}
                      onChange={(e) => {
                        handleChange(e);
                        setStatus({ password: '' });
                      }}
                      onBlur={(e) => {
                        handleBlur(e);
                        setStatus({ password: '' });
                      }}
                    />
                    <div className="span-right-showpassword">
                      <span
                        role={'button'}
                        onClick={(event) => {
                          setShowPassword(!showPassword);
                        }}
                        onKeyPress={(event) => {
                          setShowPassword(!showPassword);
                        }}
                        tabIndex={0}
                      >
                        {showPassword ? (
                          <LoginSVG.DisplayPasswordSVG />
                        ) : (
                          <LoginSVG.HidePasswordSVG />
                        )}
                      </span>
                    </div>
                    {status && status.password ? (
                      <Form.Control.Feedback type="invalid" className="mt-1">
                        <span>{status.password}</span>
                      </Form.Control.Feedback>
                    ) : (
                      errors.password && (
                        <Form.Control.Feedback type="invalid" className="mt-1">
                          <span>{errors.password}</span>
                        </Form.Control.Feedback>
                      )
                    )}
                  </Form.Group>
                  {userDetails.SuperUser !== true && (
                    <PasswordRules
                      touched={touched.password}
                      fieldValue={values.password}
                      rules={passwordRules}
                    />
                  )}
                  <Form.Group className="position-relative mb-5">
                    <Form.Label className="mb-0">
                      Confirm Password <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Control
                      type={showConfirmPassword ? 'text' : 'password'}
                      name="confirmPassword"
                      placeholder=""
                      className={
                        status && status.confirmPassword ? 'is-invalid' : ''
                      }
                      value={values.confirmPassword}
                      isInvalid={errors.confirmPassword}
                      onChange={(e) => {
                        handleChange(e);
                        //const setPass = e.currentTarget.value.trim()
                        //setOneTimePassword( setOTP )
                        setStatus({ confirmPassword: '' });
                      }}
                      onBlur={(e) => {
                        handleBlur(e);
                        //const setPass = e.currentTarget.value.trim()
                        //setOneTimePassword( setOTP )
                        setStatus({ confirmPassword: '' });
                        console.log('status', status);
                        console.log('errors', errors);
                      }}
                    />
                    <div className="span-right-showpassword">
                      <div
                        role={'button'}
                        onClick={(event) => {
                          setShowConfirmPassword(!showConfirmPassword);
                        }}
                        onKeyPress={(event) => {
                          setShowConfirmPassword(!showConfirmPassword);
                        }}
                        tabIndex={0}
                      >
                        {showConfirmPassword ? (
                          <LoginSVG.DisplayPasswordSVG />
                        ) : (
                          <LoginSVG.HidePasswordSVG />
                        )}
                      </div>
                    </div>
                    {status && status.confirmPassword ? (
                      <Form.Control.Feedback type="invalid" className="mt-1">
                        <span>{status.confirmPassword}</span>
                      </Form.Control.Feedback>
                    ) : (
                      errors.confirmPassword && (
                        <Form.Control.Feedback type="invalid" className="mt-1">
                          <span>{errors.confirmPassword}</span>
                        </Form.Control.Feedback>
                      )
                    )}
                  </Form.Group>
                  <Row>
                    <Col></Col>
                    <Col>
                      <GenericButton
                        type="submit"
                        variant="variant"
                        className="float-right"
                      >
                        Continue
                      </GenericButton>
                    </Col>
                  </Row>
                </Form>
              );
            }}
          </Formik>
        </Col>
      </Row>
    </Col>
  ) : null;
};

export default PasswordReset;
